import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import AddResidentBuilding from './components/AddResidentBuilding';


const { Cell } = ResponsiveGrid;

const ResidentBuilding = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="住戶建立棟別"
        // description="住戶建立棟別"
        breadcrumbs={[
          {
            name: '社區管理',
          },
          {
            name: '住戶建立棟別',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <AddResidentBuilding />
    </Cell>

    
  </ResponsiveGrid>
);

export default ResidentBuilding;
